import React from 'react';
import PaginationControlADG3 from './pagination_control_adg3';
import PaginationControl from './pagination_control';

export default function(props) {
  return props.use_adg3 ? (
    <PaginationControlADG3 {...props} />
  ) : (
    <PaginationControl {...props} />
  );
}
